import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ApiMessage, ApiMessageSummary } from '@type/message.type';
import { ApiResponse } from '@type/response.type';

@Injectable()
export class MessageInterceptor implements HttpInterceptor {

  constructor(
    private messageService: MessageService,
  ) { }

  intercept(req: HttpRequest<ApiResponse>, next: HttpHandler): Observable<HttpEvent<ApiResponse>> {
    return next.handle(req).pipe(
      tap({
        next: event => {
          if (event instanceof HttpResponse) {
            const messages = event.body?.messages;

            if (Array.isArray(messages)) {
              this.showApiMessages(messages);
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          const messages: ApiMessage[] = error.error?.messages;

          if (Array.isArray(messages)) {
            this.showApiMessages(messages);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Server error',
            });
          }
        },
      }),
    );
  }

  showApiMessages(messages: ApiMessage[]): void {
    const toastMessages = messages
      .filter(message => message.type === 'global')
      .map(message => {
        const severity = message.severity ?? 'error';

        return {
          severity,
          summary: ApiMessageSummary[severity],
          detail: message.message,
        };
      });

    this.messageService.addAll(toastMessages);
  }
}
